<template>
  <div id="dummy-html">
    <h5 class="mb-3">
      {{ dataComponent.name }}
    </h5>
    <div
      class="wrap-html"
      v-html="decodeHtmlEntities(JSON.parse(dataComponent.info).html)"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import he from 'he';

export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  watch: {
    dataComponent(val) {
      this.componentInfo = JSON.parse(val.info).name ? JSON.parse(val.info).name : val.widget_master.name;
      this.titleComponent = this.isMultipleUi ? this.componentInfo.multiple_form_ui_name : this.componentInfo.form_ui_name;

      this.getDetailComponent();
    },
  },

  methods: {
    decodeHtmlEntities(str) {
      return he.decode(str);
    },
  },
};
</script>

<style lang="scss">
#dummy-html {
  width: 100%;

  .wrap-html {
    width: 100%;

    p {
      width: 100%;

      img {
        width: 100%;
        height: auto;
      }
    }
    img {
      width: 100%;
      height: auto;
    }
    b, strong {
      font-weight: 600;
    }

    .ql-align-center {
      text-align: center;
    }

    .ql-align-right {
      text-align: right;
    }

    .ql-align-left {
      text-align: left;
    }

    .ql-align-justify {
      text-align: justify;
    }

    .ql-indent-1 {
      padding-left: 3em;
    }

    .ql-indent-2 {
      padding-left: 6em;
    }

    .ql-indent-3 {
      padding-left: 9em;
    }

    .ql-indent-4 {
      padding-left: 12em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyHtml.vue